// Generated by LiveScript 1.6.0
var chain, isItem, isMenu, byChain, contract, toIxChain, trimDashes, deriveExpandTexts, out$ = typeof exports != 'undefined' && exports || this;
out$.chain = chain = function(chain, index){
  index == null && (index = '');
  return trimDashes(chain + "-" + index);
};
out$.isItem = isItem = function(node){
  return node.categories == null && node.items == null;
};
out$.isMenu = isMenu = function(node){
  var ref$;
  return ((ref$ = node.categories) != null ? ref$.length : void 8) === 0;
};
out$.byChain = byChain = function(chain){
  var this$ = this;
  return function(){
    return chain === String($(this$).data('id'));
  };
};
out$.contract = contract = function(it){
  return it.join(',');
};
out$.toIxChain = toIxChain = function(it){
  if (typeof it === 'string') {
    return it.split('-');
  } else {
    return it;
  }
};
out$.trimDashes = trimDashes = function(it){
  return function(it){
    return it.replace(/[-]+$/, '');
  }(
  function(it){
    return it.replace(/^[-]+/, '');
  }(
  it));
};
out$.deriveExpandTexts = deriveExpandTexts = compose$(function(it){
  return it.split(',');
}, function(arg$){
  var collapsed, expanded;
  collapsed = arg$[0], expanded = arg$[1];
  return {
    collapsed: collapsed,
    expanded: expanded
  };
});
function compose$() {
  var functions = arguments;
  return function() {
    var i, result;
    result = functions[0].apply(this, arguments);
    for (i = 1; i < functions.length; ++i) {
      result = functions[i](result);
    }
    return result;
  };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZ1bmN0aW9ucy5scyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzthQUNPLEtBQVksQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEtBQUEsRUFBQSxLQUFBO0VBQVEsa0JBQUEsUUFBUTtTQUFPLFdBQWEsS0FBQSxDQUFBLENBQUEsQ0FBRCxHQUFBLENBQUEsQ0FBQSxDQUFFLEtBQWQ7O2NBQ3JDLE1BQVksQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLElBQUE7U0FBYyxJQUFJLENBQUMsVUFBVCxRQUFxQixDQUFBLEVBQUEsQ0FBUSxJQUFJLENBQUMsS0FBVDs7Y0FDakQsTUFBWSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsSUFBQTs7U0FBa0MsQ0FBQSxDQUFBLElBQUEsQ0FBQSxDQUFBLENBQXhCLElBQUksQ0FBQyxVQUFtQixDQUFBLFFBQUEsQ0FBeEIsRUFBd0IsSUFBUixDQUFDLE1BQU8sQ0FBQSxFQUFBLE1BQUEsQ0FBQSxDQUFBLEdBQUEsQ0FBRzs7ZUFDbkQsT0FBWSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsS0FBQTs7RUFBVyxNQUFBLENBQU8sUUFBQSxDQUFBLENBQVAsQ0FBQTtBQUFBLElBQUEsTUFBQSxDQUFVLEtBQU0sQ0FBQSxHQUFBLENBQUcsTUFBSCxDQUFVLENBQVYsQ0FBWSxLQUFELENBQU0sQ0FBQyxJQUFsQixDQUF1QixJQUFBLENBQWQsQ0FBekIsQ0FBQTtBQUFBLEVBQUEsQ0FBQTs7Z0JBQ3pCLFFBQVksQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEVBQUE7U0FBRyxFQUFFLENBQUMsS0FBSyxHQUFBOztpQkFDekIsU0FBWSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsRUFBQTtFQUFHLElBQUcsT0FBTyxFQUFHLENBQUEsR0FBQSxDQUFHLFFBQWhCO1dBQTZCLEVBQUUsQ0FBQyxNQUFNLEdBQUE7R0FBSTtXQUFLOzs7a0JBQ2hFLFVBQVksQ0FBQSxDQUFBLENBQUUsUUFBQSxDQUFBLEVBQUE7U0FBb0MsUUFBQSxDQUFBLEVBQUE7V0FBQSxFQUFBLENBQUMsUUFBUSxTQUFTLEVBQVQ7O0VBQW5DLFFBQUEsQ0FBQSxFQUFBO1dBQUEsRUFBQSxDQUFDLFFBQVEsU0FBUyxFQUFUOztFQUFoQjs7eUJBRWpCLGlCQUFvQixDQUFBLENBQUEsQ0FBZSxRQUFBLENBQVosUUFBQSxDQUFBLEVBQUEsQ0FBWSxDQUFBO0FBQUEsRUFBQSxNQUFBLENBQVosRUFBQSxDQUFDLEtBQVcsQ0FBTCxHQUFBLENBQUssQ0FBQTtBQUFBLENBQUEsRUFBRyxRQUFBLENBQUEsSUFBQSxDQUFILENBQUE7QUFBQSxNQUFBLFNBQUEsRUFBQSxRQUFBO0FBQUEsRUFBTSxTQUFOLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBQSxDQUFBLENBQUEsRUFBaUIsUUFBakIsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFBLENBQUEsQ0FBQSxDQUFBO0FBQUEsRUFBQSxNQUFBLENBQWdDLENBQWhDO0FBQUEsSUFBMUMsU0FBMEMsRUFBa0MsU0FBbEMsQ0FBQTtBQUFBLElBQTFDLFFBQTBDLEVBQTZDLFFBQTdDO0FBQUEsRUFBZ0MsQ0FBaEMsQ0FBQTtBQUFBLENBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

